// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"19a9c42c","221":"7946fa40","453":"21575617","455":"5ac23543","488":"72399f97","579":"e60382d2","638":"de9f8d6b","725":"8edf41b0","778":"60574021","977":"3f153c92"}[chunkId] + ".chunk.js";
};